import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSparkleAiColor = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M4.6867 0.837474C4.60714 0.354426 4.18956 0 3.7 0C3.21044 0 2.79286 0.354427 2.7133 0.837475C2.6133 1.44455 2.39371 1.8516 2.1155 2.1271C1.83631 2.40358 1.42903 2.61586 0.837475 2.7133C0.354427 2.79286 0 3.21044 0 3.7C0 4.18956 0.354426 4.60714 0.837474 4.6867C1.44455 4.7867 1.8516 5.00629 2.1271 5.2845C2.40358 5.56369 2.61586 5.97097 2.7133 6.56252C2.79286 7.04557 3.21044 7.4 3.7 7.4C4.18956 7.4 4.60714 7.04557 4.6867 6.56253C4.78414 5.97097 4.99642 5.56369 5.2729 5.2845C5.5484 5.00629 5.95545 4.7867 6.56253 4.6867C7.04557 4.60714 7.4 4.18956 7.4 3.7C7.4 3.21044 7.04557 2.79286 6.56252 2.7133C5.95545 2.6133 5.5484 2.39371 5.2729 2.1155C4.99642 1.83631 4.78414 1.42902 4.6867 0.837474Z",
			fill: "url(#paint0_radial_14114_126)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M11.892 0.873917C11.8285 0.374399 11.4035 0 10.9 0C10.3965 0 9.97147 0.374399 9.90798 0.873918C9.5859 3.40808 8.90209 5.2346 7.78969 6.51626C6.69227 7.78066 5.07621 8.6306 2.64499 9.01209C2.1585 9.08842 1.8 9.50756 1.8 10C1.8 10.4924 2.1585 10.9116 2.64499 10.9879C5.07621 11.3694 6.69227 12.2193 7.78969 13.4837C8.90209 14.7654 9.5859 16.5919 9.90798 19.1261C9.97147 19.6256 10.3965 20 10.9 20C11.4035 20 11.8285 19.6256 11.892 19.1261C12.2141 16.5919 12.8979 14.7654 14.0103 13.4837C15.1077 12.2193 16.7238 11.3694 19.155 10.9879C19.6415 10.9116 20 10.4924 20 10C20 9.50756 19.6415 9.08842 19.155 9.01209C16.5917 8.60987 14.9738 7.7062 13.9071 6.42658C12.8209 5.12345 12.2012 3.30628 11.892 0.873917Z",
			fill: "url(#paint1_radial_14114_126)"
		}),
		/* @__PURE__ */ _jsxs("defs", { children: [/* @__PURE__ */ _jsxs("radialGradient", {
			id: "paint0_radial_14114_126",
			cx: 0,
			cy: 0,
			r: 1,
			gradientTransform: "matrix(-11.7222 -13.5455 64.3881 -39.9541 14.5 14)",
			gradientUnits: "userSpaceOnUse",
			children: [
				/* @__PURE__ */ _jsx("stop", { stopColor: "#AF56FF" }),
				/* @__PURE__ */ _jsx("stop", {
					offset: .231415,
					stopColor: "#CE577F"
				}),
				/* @__PURE__ */ _jsx("stop", {
					offset: .481188,
					stopColor: "#EA580C"
				}),
				/* @__PURE__ */ _jsx("stop", {
					offset: .762091,
					stopColor: "#EF981D"
				}),
				/* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#F3D42C"
				})
			]
		}), /* @__PURE__ */ _jsxs("radialGradient", {
			id: "paint1_radial_14114_126",
			cx: 0,
			cy: 0,
			r: 1,
			gradientTransform: "matrix(-11.7222 -13.5455 64.3881 -39.9541 14.5 14)",
			gradientUnits: "userSpaceOnUse",
			children: [
				/* @__PURE__ */ _jsx("stop", { stopColor: "#AF56FF" }),
				/* @__PURE__ */ _jsx("stop", {
					offset: .231415,
					stopColor: "#CE577F"
				}),
				/* @__PURE__ */ _jsx("stop", {
					offset: .481188,
					stopColor: "#EA580C"
				}),
				/* @__PURE__ */ _jsx("stop", {
					offset: .762091,
					stopColor: "#EF981D"
				}),
				/* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#F3D42C"
				})
			]
		})] })
	]
});
const ForwardRef = forwardRef(SvgSparkleAiColor);
export default ForwardRef;
